import SourceDetails from './SourceDetails';

export default SourceDetails;
